// GFRCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Laju Filtrasi Glomerulus (GFR)";
const DESCRIPTION =
  "Hitung laju filtrasi glomerulus (GFR) menggunakan persamaan CKD-EPI untuk menganalisis fungsi ginjal secara akurat berdasarkan kadar kreatinin darah, usia, dan jenis kelamin.";
const KEYWORDS = "GFR, kreatinin, CKD-EPI, fungsi ginjal, kalkulator GFR";
const OG_URL = "https://do-calculate.com/calculator/id/gfr-calculator/";
function GFRCalculator() {
  const [creatinine, setCreatinine] = useState(0.2);
  const [age, setAge] = useState(12);
  const [gender, setGender] = useState("male");
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      const k = gender === "female" ? 0.7 : 0.9;
      const alpha = gender === "female" ? -0.241 : -0.302;
      const minScr = Math.min(creatinine / k, 1);
      const maxScr = Math.max(creatinine / k, 1);
      const gfr =
        142 *
        Math.pow(minScr, alpha) *
        Math.pow(maxScr, -1.2) *
        Math.pow(0.9938, age) *
        (gender === "female" ? 1.012 : 1);
      setResult(gfr.toFixed(2));
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Hitung laju filtrasi glomerulus (GFR) sekarang dan ambil langkah proaktif untuk melindungi kesehatan Anda! Kalkulator inovatif kami menggunakan persamaan medis terbaru (CKD-EPI) untuk mengevaluasi fungsi ginjal Anda secara akurat. Dengan mengetahui nilai GFR, Anda dapat:
                </p>{" "}
                <ul>
                  <li>
                    Mendeteksi penyakit ginjal sejak dini: temukan masalah ginjal pada tahap awal dan terima pengobatan yang tepat.
                  </li>
                  <li>
                    Memantau efektivitas pengobatan: pantau efek obat dan terapi pada kesehatan ginjal Anda.
                  </li>
                  <li>
                    Membuat keputusan berdasarkan informasi: konsultasikan dengan dokter Anda berdasarkan hasil perhitungan untuk menentukan rencana perawatan terbaik.
                  </li>
                </ul>
                <p>
                  Sederhananya, masukkan nilai kreatinin, usia, dan jenis kelamin, lalu klik "Hitung".
                </p>
                <p>
                  Kalkulator ini dibangun berdasarkan{" "}
                  <a href="https://www.kidney.org/ckd-epi-creatinine-equation-2021" rel="nofollow">Yayasan Ginjal Internasional</a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div >
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="creatinine">
                      <label className="form-label ms-2">
                        Masukkan kadar kreatinin
                      </label>
                      <input
                        id="creatinine"
                        type="number"
                        value={creatinine}
                        onChange={(e) => setCreatinine(e.target.value)}
                        placeholder="Masukkan kadar kreatinin"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="age">
                        Pilih usia
                      </label>
                      <select
                        id="age"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        {[...Array(88)].map((_, i) => (
                          <option key={i + 12} value={i + 12}>
                            {i + 12}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="gender">
                        Pilih jenis kelamin
                      </label>
                      <select
                        id="gender"
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="male">Laki-laki</option>
                        <option value="female">Perempuan</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Hitung
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Error: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Hasil:</h4>
                      <p className="text-white">{`Laju Filtrasi Glomerulus (GFR): ${result} ml/menit/1,73m²`}</p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">Informasi Tambahan tentang GFR</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Apa itu Laju Filtrasi Glomerulus (GFR)?{" "}
                    </h2>{" "}
                  </u>
                  <p>
                    Laju filtrasi glomerulus (GFR) adalah ukuran seberapa efisien ginjal menyaring limbah dari darah. GFR adalah alat penting untuk mengevaluasi kesehatan ginjal.
                  </p>
                  <p>
                    GFR digunakan untuk menentukan stadium penyakit ginjal kronis (CKD) dan membantu dalam perencanaan pengobatan.
                  </p>
                  <p>
                    Persamaan menggunakan faktor-faktor seperti kadar kreatinin darah, usia, dan jenis kelamin untuk menghitung GFR.
                  </p>
                  <div className="p-3 mb-2 bg-info">
                    Contoh: seseorang berusia 50 tahun, laki-laki, dengan kadar kreatinin 1,2, GFR mereka mungkin 75 ml/menit/1,73m².
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Bagaimana Cara Meningkatkan GFR?</h2>{" "}
                  </u>
                  <p>Untuk menjaga atau meningkatkan GFR, tips berikut dapat diikuti:</p>
                  <ul>
                    <li>Ikuti diet sehat.</li>
                    <li>Kontrol tekanan darah.</li>
                    <li>Berhenti merokok.</li>
                    <li>Jaga kadar gula darah dalam batas normal.</li>
                  </ul>
                  <p>Konsultasikan dengan dokter Anda untuk tips dan panduan lebih lanjut.</p>
                  <div className="p-3 mb-2 bg-info text-black">
                    Contoh: menjaga diet rendah protein dapat membantu mengurangi beban pada ginjal.
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Apa Arti GFR Rendah?</h2>{" "}
                  </u>
                  <p>
                    GFR rendah menunjukkan bahwa ginjal tidak berfungsi dengan cukup efisien. Ini mungkin berarti ada kerusakan ginjal atau perkembangan penyakit ginjal kronis.
                  </p>
                  <ul>
                    <li>
                      GFR rendah mungkin memerlukan langkah-langkah pengobatan seperti mengubah pola makan atau minum obat.
                    </li>
                    <li>
                      Dalam kasus yang parah, mungkin memerlukan prosedur medis yang lebih kompleks.
                    </li>
                  </ul>
                  <p>
                    GFR di bawah 60 ml/menit/1,73m² mungkin merupakan indikator penyakit ginjal kronis.
                  </p>
                  <b>Contoh</b>
                  <div className="p-3 mb-2 bg-info text-black">
                    Seseorang dengan GFR kurang dari 30 ml/menit/1,73m² mungkin perlu berkonsultasi dengan spesialis ginjal.
                  </div>
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>Pertanyaan Umum</h2>{" "}
                  </u>
                  <p>Berikut adalah beberapa pertanyaan umum tentang GFR:</p>
                  <b>Contoh</b>
                  <div className="p-3 mb-2 bg-info text-black ">
                    <p>T: Bisakah GFR rendah ditingkatkan?</p>
                    <p>
                      J: Dalam beberapa kasus, GFR dapat ditingkatkan dengan mengelola faktor risiko seperti tekanan darah dan gula darah.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GFRCalculator;